module.exports = __webpack_public_path__ + "img/TEXT_CARD.8139ab06.svg";